<template>
  <div class="item-box" style="margin-top: 0" id="MyActions">
    <div class="box-body px-0" style="padding-bottom: 15px;">
      <ul class="time-line follow-profil clearfix">
        <li
          class="fs-12"
          v-for="(item, index) in items"
          :key="index"
          style="    display: flex; margin-bottom: 10px;"
        >
          <div class="user-image bg-5" style="width: 6px; height: 6px; border-radius: 3px;"></div>
          <div class="detail">
            <div class="tim fs-10 fc-3 pb-1">{{$fromNow(item.action_date.date)}}</div>
            <h2
              class="font-weight-normal"
              v-html="item.action_name.replace(item.highlight, '<a class=handle_link id='+index+'>' + item.highlight + '</a>')"
            ></h2>
          </div>
        </li>
      </ul>
    </div>
    <div class="row no-gutters" @click="getdata" style="margin-top: 10px">
      <div class="col-12">
        <div class="block-link text-center pb-3">
          <h1 class="fc-1 fs-14">
            <img src="/static/img/arrow-down.svg" class="mr-2" />
            Daha Fazla Göster
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  name: "MyActions",
  data() {
    return {
      page: 0,
      items: [],
      limit: true
    };
  },
  beforeMount() {
    this.getdata();
    var self = this;
    $(document).on("click", "#MyActions .handle_link", function() {
      var index = $(this).attr("id");
      self.handleLink(self.items[index]);
    });
  },
  methods: {
    getdata() {
      this.$store.state.loading = true;
      this.page += 1;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("page", this.page);
      data.append("page_count", 5);

      axios.post("sosyal/aksiyonlarim", data).then(res => {
        this.$store.state.loading = false;
        this.items = this.items.concat(res.data.data);
      });
    },
    handleLink(item) {
      if (item.relation_type == "user") {
        this.getProfile(item.relation_id);
      }

      if (item.relation_type == "news") {
        axios.get("haber/detay?slug=" + item.relation_id).then(res => {
          this.$router.push({
            name: "NewsDetail",
            params: { data: res.data.data, slug: item.relation_id }
          });
        });
      }

      if (item.relation_type == "video") {
        axios.get("video/detay?slug=" + item.relation_id).then(res => {
          this.$router.push({
            name: "BasketDetail",
            params: { data: res.data.data, slug: res.data.data.slug }
          });
        });
      }

      if (item.relation_type == "match") {
        this.$router.push({
          name: "HomeAfterMatch",
          params: { id: item.relation_id }
        });
      }
    },
    getProfile(id) {
      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      axios.post("sosyal/profil", data).then(res => {
        if (res.data.status == 401) {
          Alert.alert("Hata", res.data.data);
          return;
        }
        this.$router.push({
          name: "UserProfile",
          params: {
            data: res.data.data,
            id: res.data.data.id,
            slug: res.data.data.slug
          }
        });
      });
    }
  }
};
</script>

<style>
.handle_link {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/MyActions.vue